import { useContext, useEffect } from 'react'
import { HubConnectionState } from '@microsoft/signalr'
import { useQueryClient } from '@tanstack/react-query'
import { SignalRContext } from '../../context/signalrContext'

export const useFileScope = (fileId: string | null, enabled = true) => {
	const { connection, isConnected, connectionEpoch } =
		useContext(SignalRContext)
	const queryClient = useQueryClient()
	useEffect(() => {
		if (
			!enabled ||
			!fileId ||
			!isConnected ||
			connection?.state !== HubConnectionState.Connected
		)
			return
		let disposed = false
		const join = async () => {
			try {
				await connection.invoke('ChangeFile', fileId)
				if (disposed) return
				await queryClient.invalidateQueries({
					queryKey: ['file', fileId],
					exact: true,
				})
				if (disposed) return
				void queryClient.invalidateQueries({
					queryKey: ['documentMetadata', fileId],
					exact: true,
				})
				await queryClient.resetQueries({
					queryKey: ['documentPreview', fileId, undefined],
					exact: true,
				})
			} catch (error) {
				if (!disposed) console.error('ChangeFile error:', error)
			}
		}
		void join()
		return () => {
			disposed = true
			if (connection.state === HubConnectionState.Connected) {
				void connection
					.invoke('ChangeFile', null)
					.catch((error) => console.error('Clear file scope error:', error))
			}
		}
	}, [connection, isConnected, connectionEpoch, fileId, enabled, queryClient])
}
